import React from 'react';

const ButtonModalOpen = ({ title, onClick, disabled, modal }) => {
    return (
        <div className='text-center'>
            <button
                className='btn  btn-outline my-3 shadow rounded' 
                disabled={disabled} 
                onClick={onClick} 
                data-bs-toggle="modal" data-bs-target={"#"+modal}
            >{title}</button>
        </div>
    )
}

export default ButtonModalOpen